import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BrandCard = ({ brand }) => {
  return (
    <Link
      to={`/brands/${brand.slug}`}
      className="brand-card relative snap-center grayscale hover:grayscale-0 transition-all duration-700 ease-out border-r border-white/10 group"
      data-testid={`brand-card-${brand.slug}`}
    >
      {/* Image */}
      <div className="absolute inset-0">
        <img
          src={brand.cover_image}
          alt={brand.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-8">
        <span className="text-xs uppercase tracking-[0.2em] text-gray-400 mb-2">
          {brand.country} · Est. {brand.founded}
        </span>
        <h3 className="text-3xl font-serif italic text-white mb-4">{brand.name}</h3>
        
        {/* Hover reveal */}
        <div className="flex items-center gap-2 text-white/0 group-hover:text-white transition-all duration-500 transform translate-y-4 group-hover:translate-y-0">
          <span className="text-sm uppercase tracking-wider">Explore Collection</span>
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
};

export default BrandCard;
